/**
 * Build our field labels for form
 */
export const getLabels = (t: Function, localState: Object) => {
  return {
    chooseAccount: t('general:actions.choose_trading_account'),
    'chooseAccount.tradingAccount': t('general:actions.choose_trading_account'),
    chooseLicense: t('general:actions.choose_license_request'),
    'chooseLicense.type': t('general:actions.choose_license_request'),
    licenseDetails: t('general:request_license.labels.details'),
    'licenseDetails.manufacturer': t('general:manufacturer'),
    'licenseDetails.product': t('general:product'),
    requiredDate: t('general:labels.required_date'),
    'requiredDate.date': t('general:labels.required_date'),
    assetDetails: t('general:request_license.labels.current_asset_details'),
    'assetDetails.assetNumber': t('general:assets.labels.number'),
    'assetDetails.serialNumber': t('general:assets.labels.serial_number'),
    'assetDetails.returnKeyCode': t('general:assets.labels.return_key_code'),
    newAssetDetails: t('general:request_license.labels.new_asset_details'),
    'newAssetDetails.assetNumber': t('general:assets.labels.number'),
    'newAssetDetails.serialNumber': t('general:assets.labels.serial_number'),
    customerDetails: t('general:labels.request_details'),
    'customerDetails.name': t('general:labels.contact_name'),
    'customerDetails.requestDate': t('general:labels.requested_date'),
    poNumber: t('general:request_license.labels.PO_number'),
    'poNumber.number': t('general:request_license.labels.PO_number'),
    comments: t('general:labels.comments'),
    'comments.comment': t('general:labels.comments'),
  };
};
